import { render, staticRenderFns } from "./history-order.vue?vue&type=template&id=2e18c504"
import script from "./history-order.vue?vue&type=script&lang=js"
export * from "./history-order.vue?vue&type=script&lang=js"
import style0 from "./history-order.vue?vue&type=style&index=0&id=2e18c504&prod&lang=scss"
import style1 from "./history-order.vue?vue&type=style&index=1&id=2e18c504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports